export default __webpack_public_path__ + "16de6a83a4787de7ca7f72a386bc659d.png";